import React, {useCallback, useEffect, useState} from 'react';
import Container from 'react-bootstrap/Container';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Table, Modal } from 'antd';
import { Button } from 'react-bootstrap';
import EditArticle from './EditArticle';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import { useAdminClient } from 'hooks/useAdminClient';

const {confirm} = Modal;

const Dashboard = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState({});
  const [articles, setArticles] = useState([]);
  const [totalArticleCount, setTotalArticleCount] = useState();
  const [page, setPage] = useState(1);
  const client = useAdminClient();
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width: '10%',
      render: (row) => {
        return moment(row.date).format('YYYY-MM-DD')
      }
    },
    {
      title: 'Preview Banner',
      key: 'img',
      render: (row) => { 
        return (<img src={`${process.env.REACT_APP_API_HOST}${row.img}`} alt="Preview" width="200" />);
      },
    },
    {
      title: 'Creator',
      dataIndex: 'creator',
      key: 'creator',
    },
    {
      title: 'Card Title',
      dataIndex: 'card_title',
      key: 'card_title',
    },
    {
      title: 'Card Description',
      dataIndex: 'card_text',
      key: 'card_text',
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'x',
      render: (row) => 
        <div style={{display: 'flex'}}>
          <Button
            variant='warning'
            onClick={() => handleEdit(row)}
            >Edit</Button>
            <Button
            variant='danger'
            onClick={() => handleDelete(row.id, row.card_title)}
            >Delete</Button>,
        </div>
    },
  ];

  const handleEdit = (row) => {
    setSelectedArticle(row);
    setShowModal(true);
  }

  const handleClose = () => {
    setShowModal(false)
  }

  const handleDelete = (rowId, cardTitle) => {
    confirm({
      title: 'Do you want to delete this articles?',
      icon: <ExclamationCircleFilled />,
      content: `Card title: ${cardTitle}`,
      async onOk() {
        await client.delete(`/be/api/v1/articles/delete/${rowId}`);
        fetchData()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Delete article success",
          showConfirmButton: false,
          timer: 1500
        });
        console.log('OK');
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const fetchData = useCallback(async (params)  => {
    const queryParams = new URLSearchParams();
    queryParams.set('page', page)
    const response = await client.get(`/be/api/v1/articles/getList?${queryParams}`);
    const {articles: data, totalCount} = response.data;
    setArticles(data);
    setTotalArticleCount(totalCount);
  }, [page])
  useEffect(() => {
    fetchData();
  }, [page])
	return (
    <div>
      <Container style={{flex: 'auto'}}>
        <h1>Article List</h1>
        <Table
          columns={columns}
          dataSource={articles}
          page={12}
          pagination={{
            total: totalArticleCount,
            onChange: (page) => setPage(page)
          }}
        />
      </Container>
      <EditArticle
        showModal={showModal}
        setShowModal={setShowModal}
        handleClose={handleClose}
        fetchData={fetchData}
        data={selectedArticle}
      />
    </div>
	);
};

export default Dashboard